import { render, staticRenderFns } from "./CustomerProcess.vue?vue&type=template&id=5bd0bed8"
import script from "./CustomerProcess.vue?vue&type=script&lang=js"
export * from "./CustomerProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd0bed8')) {
      api.createRecord('5bd0bed8', component.options)
    } else {
      api.reload('5bd0bed8', component.options)
    }
    module.hot.accept("./CustomerProcess.vue?vue&type=template&id=5bd0bed8", function () {
      api.rerender('5bd0bed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/CustomerProcess.vue"
export default component.exports